/**
 * Created by hernanherreros on 2019-05-28
 */

import * as React from 'react'

export const getEmbedParam = () => {
  const url_string = window.location.href
  const url = new URL(url_string)

  return url.searchParams.get("embed")
}

export const getSegmentUUIDParam = () => {
  const url_string = window.location.href
  const url = new URL(url_string)

  return url.searchParams.get("Segment")
}